import { Button, Col, Row } from 'antd'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { I18n } from 'react-redux-i18n'

import { bindDispatch } from '../common/util/redux'
import BasicModal from '../components/common/BasicModal'
import CompositionFilter from '../components/compositions/CompositionFilter'

import CompositionSearch from '../components/compositions/CompositionSearch'
import CompositionSortOption from '../components/compositions/CompositionSortOption'
import CompositionList from '../components/compositions/List'

import Theatres from '../components/theatres/List'

class MoviesPage extends Component {
  getCompositionOptions () {
    const {compositions: {enabledExpandAll}, actions: {toggleExpandCollapseAll}} = this.props
    return (
      <Row className="composition-options qw-pt-medium">
        <Col span={7}>
          <CompositionFilter showModal={this.props.actions.showModal}/>
        </Col>
        <Col span={7}>
          <CompositionSortOption/>
        </Col>
        <Col span={10} className='qw-right-align qw-pr-small'>
          <Button type='primary' ghost onClick={() => toggleExpandCollapseAll(!enabledExpandAll)}>
            {enabledExpandAll
              ? I18n.t('compositions.collapseAll')
              : I18n.t('compositions.expandAll')}</Button>
        </Col>
      </Row>
    )
  }

  render () {
    const {theatres, compositions, modal, compositionFilters, user} = this.props
    const {
      fetchTheatres, fetchCompositions, toggleTheatreFilter, showModal, hideModal,
      toggleSideBar, sendKDMEmail, updateTheatreSearchQuery, clearTheatreSearchQuery,
      downloadKDMs, updateCplsToOpenTheatres, loadTheatreDetails, updateSearchText
    } = this.props.actions

    return (
      <div className="movie-page">
        <Row className="movie-page-bar qw-align-middle">
          <Col span={5}
               className="movie-title qw-pl-x-large qw-pt-small qw-font-size-x-large qw-line-height-x-large qw-color-text-heading">
            {I18n.t('pages.movies')}
          </Col>
          <Col span={13}
               className="composition-search-wrap qw-flex qw-items-center qw-justify-center">
            <CompositionSearch onSearch={updateSearchText} fetchCompositions={fetchCompositions}/>
          </Col>
          <Col span={6}>
            {this.getCompositionOptions()}
          </Col>
        </Row>
        <Row>
          <Col span={theatres.showSideBar ? 6 : 1}>
            <Theatres
              theatres={theatres}
              fetchTheatres={fetchTheatres}
              toggleTheatreFilter={toggleTheatreFilter}
              toggleSideBar={toggleSideBar}
              compositionFilters={compositionFilters}
              updateTheatreSearchQuery={updateTheatreSearchQuery}
              clearTheatreSearchQuery={clearTheatreSearchQuery}
            />
          </Col>
          <Col span={theatres.showSideBar ? 18 : 23} className={'main-content'}>
            <CompositionList
              compositions={compositions}
              fetchCompositions={fetchCompositions}
              showModal={showModal}
              selectedTheatres={theatres.selectedTheatres}
              compositionFilters={compositionFilters}
              toggleTheatreFilter={toggleTheatreFilter}
              theatres={theatres}
              sendKDMEmail={sendKDMEmail}
              downloadKDMs={downloadKDMs}
              updateCplIds={updateCplsToOpenTheatres}
              loadTheatreDetails={loadTheatreDetails}
              user={user}
            />
          </Col>
          <BasicModal
            modal={modal}
            hideModal={hideModal}
          />
        </Row>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    theatres: state.theatres,
    compositions: state.compositions,
    compositionFilters: state.compositionFilters,
    modal: state.modal,
    user: state.user
  }
}

export default connect(
  mapStateToProps,
  bindDispatch
)(MoviesPage)



// WEBPACK FOOTER //
// ./src/app/pages/Movies.js